import React, { useState } from 'react';
import ConfigPagamentosDocumentacaoTab from './ConfigPagamentosDocumentacaoTab';
import ConfigPagamentosConfiguracaoTab from './ConfigPagamentosConfiguracaoTab';

interface ConfigPagamentosTabProps {
  ligaId: string;
}

const ConfigPagamentosTab: React.FC<ConfigPagamentosTabProps> = ({ ligaId }) => {
  const [activeSubTab, setActiveSubTab] = useState('configuracao');

  return (
    <div>
      {/* Nested Tabs Navigation */}
      <ul className="nav nav-tabs mb-3" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeSubTab === 'configuracao' ? 'active' : ''}`}
            type="button"
            onClick={() => setActiveSubTab('configuracao')}
            role="tab"
            aria-selected={activeSubTab === 'configuracao'}
          >
            Configuração
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={`nav-link ${activeSubTab === 'documentacao' ? 'active' : ''}`}
            type="button"
            onClick={() => setActiveSubTab('documentacao')}
            role="tab"
            aria-selected={activeSubTab === 'documentacao'}
          >
            Documentação
          </button>
        </li>
      </ul>

      {/* Nested Tabs Content */}
      <div className="tab-content">
        <div
          className={`tab-pane fade ${activeSubTab === 'configuracao' ? 'show active' : ''}`}
          role="tabpanel"
        >
          <ConfigPagamentosConfiguracaoTab ligaId={ligaId} />
        </div>

        <div
          className={`tab-pane fade ${activeSubTab === 'documentacao' ? 'show active' : ''}`}
          role="tabpanel"
        >
          <ConfigPagamentosDocumentacaoTab ligaId={ligaId} />
        </div>
      </div>
    </div>
  );
};

export default ConfigPagamentosTab;
